<template>
  <div class="flex -mx-4">
    <div class="w-full px-4 flex flex-col">
      <div class="bg-white rounded-lg p-4 md:p-6 pt-0 mt-6">
        <div class="flex items-center border-b mb-2 md:mb-6 pb-0 md:pb-2">
          <div class="w-16 md:w-32 h-16 md:h-32 -mt-6 md:-mt-12 mb-2 rounded-lg relative flex flex-no-shrink justify-center items-center"
                :class="page.icon_color ? page.icon_color : 'bg-tertiary'">
            <i
              v-if="page.icon"
              class="fas page-icon text-white"
              :class="`fa-${page.icon}`"
            ></i>
            <i
              v-else
              class="fas page-icon text-white fa-file-alt"
            ></i>
          </div>
          <div class="mx-2 md:mx-6">
            <tabulated-controls :tabs="tabsToDisplay" v-model="currentTab" class="w-full lg:w-5/6">
            </tabulated-controls>
          </div>
        </div>

        <div>
          <tabulated-pages :tabs="tabsToDisplay" :active="currentTab" class="w-full">
            <div v-for="(tab, index) in tabsToDisplay" :key="index" :slot="tab.id">
              <div v-for="(formControl, index) in tab.form" :key="index"
                   :is="`form-${formControl.type}`" :label="formControl.label"
                   :info="formControl.info" :value="formControl.value"
                   :field="formControl.field">
              </div>
            </div>
          </tabulated-pages>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'Settings',
  props: ['settings', 'page', 'icon'],
  data () {
    return {
      selectedTab: null
    }
  },
  computed: {
    currentTab: {
      get: function () {
        if (this.selectedTab) {
          return this.selectedTab
        }
        return this.settings.length ? _.head(this.settings).id : ''
      },
      set: function (value) {
        this.selectedTab = value
      }
    },
    tabsToDisplay () {
      return _.map(this.settings, (item) => {
        return {
          id: item.id,
          title: item.title,
          icon: ''
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
